<template>
  <div class="container-404 no-margin" style="margin-top: 10vh !important; margin-right: 50px !important">
    <h1 class="no-margin" style="font-weight: bold;">{{$t('errors.ups')}}</h1>
    <!--<h1 class="err-404 no-margin">404</h1>-->
    <div style="height: 30vh;">
      <img src="../../assets/notfound.svg" style="height: 100%; width: 100%;" />
    </div>
    <h1 class="no-margin" style="font-weight: bold; text-align: center;">{{$t('errors.pageNotFound')}}</h1>
  </div>
</template>

<script>

export default {
  data () {
    return {
      statusCode: this.$route.meta.statusCode
    }
  }
}
</script>

<style>
.no-margin {
  margin: 0px;
  padding: 0px;
}

.err-404 {
  font-size: 50px;
  font-weight: bold;
  color: #4AA362;
}

.container-404 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}
</style>




// WEBPACK FOOTER //
// PageNotFound.vue?4b6f34dc